import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { AnimatedTextFallback } from '../../atoms/animatedFallbacks'
import { Button } from '@techmobilt/ui-components'
import { If } from '../../atoms/if'
import { Text } from '../../atoms/text'
import {
  StyledGameDescriptionWrapper,
  StyledImageWrapper,
  StyledPlayForFunButton,
  StyledTextWrapper,
} from './styles'
import useSlugs from '../../../hooks/useSlugs'
import { game_proptype } from '../../../propTypes'
import { useTranslation } from '../../../context/translationProvider'
import { AuthContext } from '../../../context/authProvider'
import { ResponsibleGaming } from '../../molecules/responsibleGaming'
import { ResponsiveImage } from '../../atoms/responsiveImage'
import Link from '../../atoms/link'

const GameDescription = (props) => {
  const { translate } = useTranslation()
  const { game, setDidReadSEO, isUnderMaintenance, disablePlayForFun } = props
  const { seo_image, thumbnail_tall } = game
  const [loginSlug] = useSlugs(['login'])
  const { isLoggedIn } = useContext(AuthContext)

  const buttonLabel = isUnderMaintenance
    ? 'game.login_button'
    : 'casino.playForReal'
  return (
    <StyledGameDescriptionWrapper>
      <Button
        customLinkComponent={Link}
        $customHrefName="to"
        href={`/${loginSlug}/`}
        style={{ minWidth: '206px', maxWidth: '85%' }}
        id="play-for-real-button"
      >
        {translate(buttonLabel)}
      </Button>
      <StyledImageWrapper>
        <ResponsiveImage image={seo_image || thumbnail_tall} />
        <img src={game?.responsibleGaming?.over_18_icon?.url} />
      </StyledImageWrapper>
      <If
        condition={isUnderMaintenance}
        render={() => (
          <StyledTextWrapper>
            <Text>{translate('game.maintenance_mode_message')}</Text>
          </StyledTextWrapper>
        )}
        renderElse={() => (
          <If
            condition={!disablePlayForFun && !isLoggedIn}
            render={() => (
              <StyledPlayForFunButton onClick={() => setDidReadSEO(true)}>
                {translate('casino.playForFun') ?? (
                  <AnimatedTextFallback level={3} />
                )}
              </StyledPlayForFunButton>
            )}
          />
        )}
      />
      <ResponsibleGaming responsibleGaming={game?.responsibleGaming} />
    </StyledGameDescriptionWrapper>
  )
}

GameDescription.defaultProps = {
  isUnderMaintenance: false,
  disablePlayForFun: false,
  game: {},
}

GameDescription.propTypes = {
  setDidReadSEO: PropTypes.func.isRequired,
  isUnderMaintenance: PropTypes.bool,
  disablePlayForFun: PropTypes.bool,
  game: game_proptype,
}

export { GameDescription }
